import { useMemo } from 'react';
import { toast } from 'react-toastify';
import { useQuery } from '@apollo/client';
import { GET_ALL_ANALYTICS } from 'graphql/queries/analytics';
import { AllAnalyticsResult } from 'types/analytics.types';
import { getDateMonthsFromNow } from 'utils/dates';

export const useOverallAnalytics = () => {
  // Always start the data 3 months from now.
  const startDate: string = useMemo(() => {
    return getDateMonthsFromNow(3);
  }, []);

  return useQuery<AllAnalyticsResult>(GET_ALL_ANALYTICS, {
    onError: () => {
      toast('Something went wrong while fetching all analytics data.');
    },
    variables: {
      params: {
        startDate,
      },
    },
  });
};
